<script >
/** 依赖引入 start */
import { ref, onMounted, computed } from 'vue-demi';
import '@futuweb/community-activity-modules/lib/vue2/style.px.css';
import { formatStockPageMainInfo } from '@futuweb/community-activity-modules/lib/utils/format.js';
import { EMPTY_CONTENT_STATUS } from '@futuweb/community-activity-modules/lib/constants/empty-content-status.js';
import { FAProviderConfig } from '@futuweb/community-activity-modules/lib/vue2/provider-config/index.es.js';
import { FAEnterpriseBaseInfo } from '@futuweb/community-activity-modules/lib/vue2/enterprise-base-info/index.es.js';
import { FAFinancialReportSkimming } from '@futuweb/community-activity-modules/lib/vue2/financial-report-skimming/index.es.js';
import { FAEnterpriseSay } from '@futuweb/community-activity-modules/lib/vue2/enterprise-say/index.es.js';
import { FAAnalystRatings } from '@futuweb/community-activity-modules/lib/vue2/analyst-ratings/index.es.js';
import { FANewsList } from '@futuweb/community-activity-modules/lib/vue2/news-list/index.es.js';
import { FACommunityArticleList } from '@futuweb/community-activity-modules/lib/vue2/community-article-list/index.es.js';
import QANew from '../modules/QANew';
import Gap from '../components/Gap';
import { optionalChaining, isMoo, getIsPreRender, isH5 } from '../utils';
import { SKIN_NUM, MODULE } from '../constants';
import { LANG_NUM_MAP } from '../constants/i18n';
const __sfc_main = {};
__sfc_main.props = {
  tpl: {
    type: Object,
    default: () => ({})
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useCommonApi
  } = require('@fegobull/webapi').use;
  const {
    get: ApiGet
  } = useCommonApi('multi-media-financial-report');

  /** 依赖引入 end */

  /** props 定义 */
  const props = __props;
  const langNum = computed(() => {
    return LANG_NUM_MAP[props.tpl.props.language];
  });
  const skinNum = computed(() => {
    return SKIN_NUM[props.tpl.props.skin];
  });
  const quoteColor = computed(() => {
    return props.tpl.props.stockColor;
  });
  const stockId = computed(() => {
    return props.tpl.props.stockId;
  });
  const isMooSite = computed(() => {
    return isMoo();
  });

  /** 页面主要数据请求 */
  const ALL_STATUS = ref(EMPTY_CONTENT_STATUS.LOADING);
  const stockPageMainInfo = ref({});
  const quoteList = ref([]);
  const targetEstimateInfoList = ref([]);
  const financeStockReportList = ref([]);
  const stockInfos = ref([]);
  const financialCalendar = ref({
    calendar: [],
    stockInfo: []
  });
  const baseInfo = ref({});
  const questionAnswer = ref({});
  const isPreRender = getIsPreRender();
  const hasData = ref(false);

  /** 模块是否展示计算 */
  const showSelfBanner = computed(() => {
    return props.tpl.props.module.includes(MODULE.SELF_BANNER);
  });
  const showEasilyRead = computed(() => {
    return props.tpl.props.module.includes(MODULE.EASILY_READ);
  });
  const showEntSay = computed(() => {
    return props.tpl.props.module.includes(MODULE.ENT_SAY);
  });
  const showQA = computed(() => {
    return props.tpl.props.module.includes(MODULE.QA);
  });
  const showInterpretation = computed(() => {
    return props.tpl.props.module.includes(MODULE.INTERPRETATION);
  });
  const showAnalystRating = computed(() => {
    return props.tpl.props.module.includes(MODULE.ANALYST_RATING);
  });
  const showNews = computed(() => {
    return props.tpl.props.module.includes(MODULE.NEWS);
  });
  const showSkimmingOperatingData = computed(() => {
    return props.tpl.props.module.includes(MODULE.SKIMMING_OPERATING_DATA);
  });
  const showAnalystRatingNews = computed(() => {
    return props.tpl.props.module.includes(MODULE.ANALYST_RATING_CHART_NEWS);
  });
  const showGap = computed(() => {
    return ALL_STATUS.value === EMPTY_CONTENT_STATUS.SUCCESS;
  });
  const calcChartOptionRem = computed(() => {
    let rem = 1;
    if (isH5()) {
      // 获取屏幕宽度
      const screenWidth = window.screen.width;
      const rate = screenWidth / 375;
      rem = rem * rate;
    } else {
      rem = 2;
    }
    return rem;
  });
  async function onRequestData() {
    try {
      if (!props.tpl.props.pageId) {
        return;
      }
      const res = await ApiGet('data', {
        pageId: props.tpl.props.pageId,
        lang: langNum.value
      }, {
        group: null
      });
      hasData.value = res && Object.keys(res).length > 0;
      if (!hasData.value) {
        ALL_STATUS.value = EMPTY_CONTENT_STATUS.NONE;
        return;
      }
      questionAnswer.value = res.questionAnswer || {};
      baseInfo.value = res.baseInfo || {};
      stockPageMainInfo.value = formatStockPageMainInfo(res);
      await onRequestStockInfos();
      ALL_STATUS.value = EMPTY_CONTENT_STATUS.SUCCESS;
    } catch (error) {
      console.error('Error: FinancialReportCmp', error);
      ALL_STATUS.value = EMPTY_CONTENT_STATUS.ERROR;
    }
  }
  /** 基本信息，股票信息获取 */
  async function onRequestStockInfos() {
    const stockIdSet = stockPageMainInfo.value?.stockPageMainInfo?.stockIdSet || [];
    if (stockIdSet?.length) {
      const stockInfosRes = await ApiGet('stockInfos', {
        stockIds: stockIdSet.join(','),
        lang: langNum.value
      }, {
        group: null
      });
      stockInfos.value = stockInfosRes;
    }
  }
  /** 财报日历 */
  async function onRequestFinancialCalendar() {
    const financialCalendarRes = await ApiGet('financialCalendar', {
      lang: langNum.value
    }, {
      group: null
    });
    financialCalendar.value = financialCalendarRes;
  }
  /** 经营数据图表 */
  async function onRequestQuoteList() {
    if (!stockId.value) {
      return;
    }
    const quoteListRes = await ApiGet('quoteList', {
      stockId: stockId.value,
      lang: langNum.value
    }, {
      group: null
    });
    quoteList.value = quoteListRes;
  }
  /** 分析师评级目标预测价图表 */
  async function onRequestTargetEstimateInfo() {
    if (!stockId.value) {
      return;
    }
    const targetEstimateInfoRes = await ApiGet('targetEstimateInfo', {
      stockId: stockId.value,
      lang: langNum.value
    }, {
      group: null
    });
    targetEstimateInfoList.value = targetEstimateInfoRes;
  }
  /** 分析师评级部分财报资讯获取 */
  async function onRequestFinanceStockReportList() {
    if (!stockId.value || !props.tpl.props.pageId) {
      return;
    }
    const financeStockReportListRes = await ApiGet('financeStockReportList', {
      stockId: stockId.value,
      pageId: props.tpl.props.pageId,
      lang: langNum.value
    }, {
      group: null
    });
    financeStockReportList.value = financeStockReportListRes;
  }
  function onJump(data) {
    return;
  }

  /** mounted 钩子 */
  onMounted(async () => {
    if (isPreRender) {
      return;
    }
    const reqArr = [onRequestData(),
    // 请求页面主要数据
    onRequestFinancialCalendar() // 请求财报日历
    ];
    showSkimmingOperatingData.value && reqArr.push(onRequestQuoteList());
    (showAnalystRatingNews.value || showAnalystRating.value) && reqArr.push(onRequestTargetEstimateInfo());
    showAnalystRatingNews.value && reqArr.push(onRequestFinanceStockReportList());
    await Promise.all(reqArr);
  });
  return {
    optionalChaining,
    props,
    langNum,
    skinNum,
    quoteColor,
    stockId,
    isMooSite,
    ALL_STATUS,
    stockPageMainInfo,
    quoteList,
    targetEstimateInfoList,
    financeStockReportList,
    stockInfos,
    financialCalendar,
    baseInfo,
    questionAnswer,
    isPreRender,
    hasData,
    showSelfBanner,
    showEasilyRead,
    showEntSay,
    showQA,
    showInterpretation,
    showAnalystRating,
    showNews,
    showSkimmingOperatingData,
    showAnalystRatingNews,
    showGap,
    calcChartOptionRem,
    onJump
  };
};
__sfc_main.components = Object.assign({
  FAProviderConfig,
  FAEnterpriseBaseInfo,
  Gap,
  FAFinancialReportSkimming,
  QANew,
  FAEnterpriseSay,
  FAAnalystRatings,
  FANewsList,
  FACommunityArticleList
}, __sfc_main.components);
export default __sfc_main;
</script>
<template>
    <div
        class="multi-media-financial-report-wrapper"
        :class="[props.tpl.props.language]"
    >
        <div v-if="isPreRender" key="hideContent"></div>
        <div v-else key="showContent">
            <FAProviderConfig
                v-if="props.tpl.props.pageId && hasData"
                :lang="langNum"
                :skin="skinNum"
                :quoteColor="quoteColor"
                :siteLocation="isMooSite ? 'US' : 'CN'"
            >
                <!-- announce 相关状态暂不需要 -->
                <FAEnterpriseBaseInfo
                    v-if="showSelfBanner"
                    :style="{
                        padding: '0.24rem 0.36rem 0.32rem'
                    }"
                    :baseInfo="(stockPageMainInfo && stockPageMainInfo.stockPageMainInfo) || {}"
                    :stockInfo="(stockInfos && stockInfos.stockInfoItems) || []"
                    :calendarInfo="{ ...financialCalendar, showCount: 3 } || {}"
                    @jump="onJump"
                    @subscribe="onJump"
                    @unsubscribe="onJump"
                />
                <!-- 财报速览 -->
                <Gap v-if="showGap" />
                <FAFinancialReportSkimming
                    v-if="showEasilyRead || showSkimmingOperatingData"
                    :moduleStatus="ALL_STATUS"
                    :summarize="showEasilyRead
                        ? {
                            label: optionalChaining(stockPageMainInfo, 'financialReportSetting', 'summarize', 'category'),
                            describe: optionalChaining(stockPageMainInfo, 'financialReportSetting', 'summarize', 'content')
                        }
                        : {}"
                    :financialData="showEasilyRead
                        ? {
                            data: optionalChaining(stockPageMainInfo, 'stockInfo', optionalChaining(stockPageMainInfo, 'stockPageMainInfo', 'mainStockId')),
                            stockInfo: {
                                stockId: optionalChaining(stockPageMainInfo, 'financialReportSetting', 'financialReportSkimming', 'stockId')
                            }
                        }
                        : {}"
                    :copyData="showEasilyRead
                        ?(stockPageMainInfo && stockPageMainInfo.financialReportSetting && stockPageMainInfo.financialReportSetting.copy)
                        : []"
                    :originalText="showEasilyRead ? (optionalChaining(stockPageMainInfo, 'financialReportSetting', 'originalText') || []) : []"
                    :currentCode="showEasilyRead ? (optionalChaining(stockPageMainInfo, 'financialReportSetting', 'currencyCode')) : ''"
                    @jump="onJump"
                    :operatingData="
                        showSkimmingOperatingData ?
                            (quoteList ? {
                                dataSource: [{
                                    stockInfo: { stockId },
                                    chartInfo: quoteList
                                }],
                                chartOption: {
                                    rem: calcChartOptionRem
                                }
                            }: [])
                        : []
                    "
                />
                <Gap v-if="showGap" />
                <QANew
                    v-if="showQA"
                    :moduleStatus="ALL_STATUS"
                    :language="tpl.props.language"
                    :info="questionAnswer"
                    :baseInfo="baseInfo"
                    @clickRule="onJump"
                    @clickMore="onJump"
                />
                <Gap v-if="showGap" />
                <!-- 企业说财报 -->
                <FAEnterpriseSay
                    v-if="showEntSay"
                    :reportTime="optionalChaining(stockPageMainInfo, 'financialReportSetting', 'reportTime') || 0"
                    :call="optionalChaining(stockPageMainInfo, 'financialReportSetting', 'enterpriseAnalysis', 'meeting') || []"
                    :highlight="optionalChaining(stockPageMainInfo, 'financialReportSetting', 'enterpriseAnalysis', 'highlight') || []"
                    :moduleStatus="ALL_STATUS"
                    @jump="onJump"
                    @subscribe="onJump"
                    @unsubscribe="onJump"
                />
                <Gap v-if="showGap" />
                <!-- 分析师评级 -->
                <FAAnalystRatings
                    v-if="showAnalystRating || showAnalystRatingNews"
                    :moduleStatus="ALL_STATUS"
                    :data="targetEstimateInfoList"
                    :financialStockResearch="showAnalystRatingNews ? {list: financeStockReportList} : { list: [] }"
                    :isVisable="optionalChaining(stockPageMainInfo, 'financialReportSetting', 'analystRating', 'visiable')"
                    :pageBindStockNumber="optionalChaining(stockPageMainInfo, 'stockPageMainInfo', 'stockIdSet', 'length') || 0"
                    @jump="onJump"
                />
                <Gap v-if="showGap" />
                <!-- 内部会根据 newsList 判断是否显示 -->
                <!-- 新闻资讯 -->
                <FANewsList
                    v-if="showNews"
                    :moduleStatus="ALL_STATUS"
                    :newsList="(optionalChaining(stockPageMainInfo, 'financialReportSetting', 'newsAnalysis') || []).slice(0, 3)"
                    @jump="onJump"
                />
                <Gap v-if="showGap" />
                <!-- 大咖观点 -->
                <FACommunityArticleList
                    v-if="showInterpretation"
                    :list="optionalChaining(stockPageMainInfo, 'financialReportSetting', 'communityAnalysis') || []"
                    :moduleStatus="ALL_STATUS"
                    @clickCard="onJump"
                    @subscribe="onJump"
                    @unsubscribe="onJump"
                    @clickAnthor="onJump"
                />
            </FAProviderConfig>
            <div class="mask"></div>
        </div>
    </div>
</template>
<style lang="less" scoped>
.multi-media-financial-report-wrapper {
    height: auto !important;
    position: relative;
    font-family: "BR Hendrix", "PingFang SC", "PingFang HK", -apple-system, "Microsoft YaHei", "Helvetica Neue",
        Helvetica, Arial, sans-serif, "ヒラギノ角ゴ Pro W3","Hiragino Kaku Gothic Pro",Meiryo,"ＭＳ Ｐゴシック","MS PGothic";
    &.ja {
        font-family: "ヒラギノ角ゴ Pro W3","Hiragino Kaku Gothic Pro",Meiryo,"ＭＳ Ｐゴシック","MS PGothic", "BR Hendrix",
            "PingFang SC", "PingFang HK", -apple-system, "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif;
    }
    .mask {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }
    // 覆盖样式
    /deep/ [class^="_financial-stock-research-item-wrapper"]:last-child {
        margin-bottom: 0;
    }
    /deep/ [class^="_target-estimate-info"]:last-child {
        margin-bottom: 0;
    }
    /deep/ [class^="_financial-report-skimming-wrapper"]:last-child {
        margin-bottom: 0;
    }
    /deep/ [class^="_news-list-wrapper__item-wrapper"]:last-child {
        margin-bottom: 0;
    }
}
</style>
